export enum SettingsSection {
  PROFILE = 'PROFILE',
  PREFERENCES = 'PREFERENCES',
  REPORT_BUG = 'REPORT_BUG'
}
